export const StreetType = {
  Abbey: 1,
  Acres: 2,
  Allée: 3,
  Alley: 4,
  Autoroute: 5,
  Avenue: 6,
  Bay: 7,
  Beach: 8,
  Bend: 9,
  Boulevard: 10,
  ByPass: 11,
  Byway: 12,
  Campus: 13,
  Cape: 14,
  Carré: 15,
  Carrefour: 16,
  Centre: 17,
  Cercle: 18,
  Chase: 19,
  Chemin: 20,
  Circle: 21,
  Circuit: 22,
  Close: 23,
  Common: 24,
  Concession: 25,
  Corners: 26,
  Côte: 27,
  Cour: 28,
  Cours: 29,
  Court: 30,
  Cove: 31,
  Crescent: 32,
  Croissant: 33,
  Crossing: 34,
  CulDeSac: 35,
  Dale: 36,
  Dell: 37,
  Diversion: 38,
  Downs: 39,
  Drive: 40,
  Échangeur: 41,
  End: 42,
  Esplanade: 43,
  Estates: 44,
  Expressway: 45,
  Extension: 46,
  Farm: 47,
  Field: 48,
  Forest: 49,
  Freeway: 50,
  Front: 51,
  Gardens: 52,
  Gate: 53,
  Glade: 54,
  Glen: 55,
  Green: 56,
  Grounds: 57,
  Grove: 58,
  Harbour: 59,
  Heath: 60,
  Heights: 61,
  Highlands: 62,
  Highway: 63,
  Hill: 64,
  Hollow: 65,
  Île: 66,
  Impasse: 67,
  Inlet: 68,
  Island: 69,
  Key: 70,
  Knoll: 71,
  Landing: 72,
  Lane: 73,
  Limits: 74,
  Line: 75,
  Link: 76,
  Lookout: 77,
  Loop: 78,
  Mall: 79,
  Manor: 80,
  Maze: 81,
  Meadow: 82,
  Mews: 83,
  Montée: 84,
  Moor: 85,
  Mount: 86,
  Mountain: 87,
  Orchard: 88,
  Parade: 89,
  Parc: 90,
  Park: 91,
  Parkway: 92,
  Passage: 93,
  Path: 94,
  Pathway: 95,
  Pines: 96,
  Place: 97,
  Plateau: 98,
  Plaza: 99,
  Point: 100,
  Pointe: 101,
  Port: 102,
  Private: 103,
  Promenade: 104,
  Quai: 105,
  Quay: 106,
  Ramp: 107,
  Rang: 108,
  Range: 109,
  Ridge: 110,
  Rise: 111,
  Road: 112,
  RondPoint: 113,
  Route: 114,
  Row: 115,
  Rue: 116,
  Ruelle: 117,
  Run: 118,
  Sentier: 119,
  Square: 120,
  Street: 121,
  Subdivision: 122,
  Terrace: 123,
  Terrasse: 124,
  Thicket: 125,
  Towers: 126,
  Townline: 127,
  Trail: 128,
  Turnabout: 129,
  Vale: 130,
  Via: 131,
  View: 132,
  Village: 133,
  Villas: 134,
  Vista: 135,
  Voie: 136,
  Walk: 137,
  Way: 138,
  Wharf: 139,
  Wood: 140,
  Wynd: 141,
}

export const StreetTypeString = {
  1: 'Abbey',
  2: 'Acres',
  3: 'Allée',
  4: 'Alley',
  5: 'Autoroute',
  6: 'Avenue',
  7: 'Bay',
  8: 'Beach',
  9: 'Bend',
  10: 'Boulevard',
  11: 'ByPass',
  12: 'Byway',
  13: 'Campus',
  14: 'Cape',
  15: 'Carré',
  16: 'Carrefour',
  17: 'Centre',
  18: 'Cercle',
  19: 'Chase',
  20: 'Chemin',
  21: 'Circle',
  22: 'Circuit',
  23: 'Close',
  24: 'Common',
  25: 'Concession',
  26: 'Corners',
  27: 'Côte',
  28: 'Cour',
  29: 'Cours',
  30: 'Court',
  31: 'Cove',
  32: 'Crescent',
  33: 'Croissant',
  34: 'Crossing',
  35: 'CulDeSac',
  36: 'Dale',
  37: 'Dell',
  38: 'Diversion',
  39: 'Downs',
  40: 'Drive',
  41: 'Échangeur',
  42: 'End',
  43: 'Esplanade',
  44: 'Estates',
  45: 'Expressway',
  46: 'Extension',
  47: 'Farm',
  48: 'Field',
  49: 'Forest',
  50: 'Freeway',
  51: 'Front',
  52: 'Gardens',
  53: 'Gate',
  54: 'Glade',
  55: 'Glen',
  56: 'Green',
  57: 'Grounds',
  58: 'Grove',
  59: 'Harbour',
  60: 'Heath',
  61: 'Heights',
  62: 'Highlands',
  63: 'Highway',
  64: 'Hill',
  65: 'Hollow',
  66: 'Île',
  67: 'Impasse',
  68: 'Inlet',
  69: 'Island',
  70: 'Key',
  71: 'Knoll',
  72: 'Landing',
  73: 'Lane',
  74: 'Limits',
  75: 'Line',
  76: 'Link',
  77: 'Lookout',
  78: 'Loop',
  79: 'Mall',
  80: 'Manor',
  81: 'Maze',
  82: 'Meadow',
  83: 'Mews',
  84: 'Montée',
  85: 'Moor',
  86: 'Mount',
  87: 'Mountain',
  88: 'Orchard',
  89: 'Parade',
  90: 'Parc',
  91: 'Park',
  92: 'Parkway',
  93: 'Passage',
  94: 'Path',
  95: 'Pathway',
  96: 'Pines',
  97: 'Place',
  98: 'Plateau',
  99: 'Plaza',
  100: 'Point',
  101: 'Pointe',
  102: 'Port',
  103: 'Private',
  104: 'Promenade',
  105: 'Quai',
  106: 'Quay',
  107: 'Ramp',
  108: 'Rang',
  109: 'Range',
  110: 'Ridge',
  111: 'Rise',
  112: 'Road',
  113: 'RondPoint',
  114: 'Route',
  115: 'Row',
  116: 'Rue',
  117: 'Ruelle',
  118: 'Run',
  119: 'Sentier',
  120: 'Square',
  121: 'Street',
  122: 'Subdivision',
  123: 'Terrace',
  124: 'Terrasse',
  125: 'Thicket',
  126: 'Towers',
  127: 'Townline',
  128: 'Trail',
  129: 'Turnabout',
  130: 'Vale',
  131: 'Via',
  132: 'View',
  133: 'Village',
  134: 'Villas',
  135: 'Vista',
  136: 'Voie',
  137: 'Walk',
  138: 'Way',
  139: 'Wharf',
  140: 'Wood',
  141: 'Wynd',
}
